import { useTranslation } from 'module/hooks/use-translation';
import { Dialog } from '@rocketlane/ui';
import { ReactNode, useCallback, useState } from 'react';

interface DeleteConfirmDialogConfig {
  title?: ReactNode;
  content?: ReactNode;
  width?: number;
  okText?: ReactNode;
  cancelText?: ReactNode;
  onOk?: () => void | Promise<void>;
  onCancel?: () => void;
}

interface DeleteConfirmDialogResult {
  open: () => void;
  dialog: ReactNode;
}

export const useDeleteConfirmModal = ({
  title,
  content,
  width,
  okText: configuredOkText,
  cancelText: configuredCancelText,
  onOk,
  onCancel,
}: DeleteConfirmDialogConfig = {}): DeleteConfirmDialogResult => {
  const [open, setOpen] = useState(false);
  const okText = useTranslation('delete');
  const cancelText = useTranslation('cancel');
  const openDialog = useCallback(() => setOpen(true), []);

  return {
    open: openDialog,
    dialog: (
      <Dialog
        open={open}
        onOpenChange={setOpen}
        onCancel={onCancel}
        onAction={onOk}
        title={title}
        content={content}
        width={width}
        variant="danger"
        cancelProps={{ text: configuredCancelText ?? cancelText }}
        actionProps={{ text: configuredOkText ?? okText }}
      />
    ),
  };
};
